import { useEffect, useState } from "react";
import { api, euro } from "@/lib/api";

const FILTERS = [["paid", "Pagati"], ["coaching", "Training"], ["guide", "Guide"], ["all", "Tutti i checkout"]];
const match = (o, f) => {
  if (f === "all") return true;
  if (o.payment_status !== "paid") return false;
  if (f === "coaching") return o.kind === "coaching";
  if (f === "guide") return o.kind !== "coaching";
  return true;
};

export const OrdersPanel = () => {
  const [orders, setOrders] = useState([]);
  const [f, setF] = useState("paid");
  useEffect(() => {
    api.get("/admin/orders").then((r) => setOrders(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, []);
  const shown = orders.filter((o) => match(o, f));
  const total = shown.filter((o) => o.payment_status === "paid").reduce((t, o) => t + (o.amount || 0), 0);

  return (
    <div data-testid="orders-panel">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-wrap gap-2">
          {FILTERS.map(([k, label]) => (
            <button key={k} type="button" data-testid={`orders-filter-${k}`} onClick={() => setF(k)}
              className={`rounded-full border px-4 py-1.5 font-mono text-xs uppercase tracking-widest ${f === k ? "border-[#c4dcca] bg-[#c4dcca] text-[#050807]" : "border-white/15 text-[#a3b1aa]"}`}>{label}</button>
          ))}
        </div>
        <p data-testid="orders-total" className="font-mono text-sm text-[#c4dcca]">Incassato: {euro(total)}</p>
      </div>
      {shown.length === 0 && <p data-testid="orders-empty" className="text-[#a3b1aa]">Nessun ordine.</p>}
      <div className="divide-y divide-white/5 border border-[rgba(152,191,162,0.15)]">
        {shown.map((o) => (
          <div key={o.session_id} data-testid={`order-row-${o.session_id}`} className="flex flex-wrap items-center justify-between gap-3 p-4">
            <div className="min-w-0">
              <p className="text-sm">{o.label || (o.items || []).map((i) => `${i.name} ×${i.quantity}`).join(", ")}</p>
              <p className="font-mono text-xs text-[#a3b1aa]">{o.created_at ? new Date(o.created_at).toLocaleString("it-IT") : ""} {o.customer_email ? `· ${o.customer_email}` : ""}</p>
            </div>
            <div className="flex items-center gap-4">
              <span className={`font-mono text-xs uppercase ${o.payment_status === "paid" ? "text-[#c4dcca]" : "text-[#a3b1aa]"}`}>{o.payment_status === "paid" ? "pagato" : "non completato"}</span>
              <span className="font-mono text-sm">{euro(o.amount)}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
